import React from "react";
import { Row, Col, Badge, Tooltip } from "antd";

const BookingStatusWidgetV2 = () => {
  const statusData = [
    {
      status: "1",
      label: "Available",
      color: "#55efc4",
    },
    {
      status: "0",
      label: "Booked",
      color: "#ff7675",
    },
    {
      status: "2",
      label: "Disabled",
      color: "#ecf0f1",
    },
    {
      status: "3",
      label: "Pending",
      color: "#FFD700",
    },
    {
      status: "4",
      label: "On Going",
      color: "#006400",
    },
    {
      status: "5",
      label: "Completed",
      color: "#90EE90",
    },
    {
      status: "6",
      label: "Cancelled",
      color: "#FF7F7F",
    },
    {
      status: "7",
      label: "Accepted",
      color: "#FFA500",
    },
  ];

  return (
    <Row gutter={16}>
      {statusData.map((statusItem) => (
        <Col
          xs={24} // Full width on small screens (1 item per row)
          sm={12} // Half-width on small screens (2 items per row)
          md={6} // 1/4 width on medium screens (4 items per row)
          lg={4} // 1/6 width on large screens (6 items per row)
          xl={3} // 1/8 width on extra-large screens (8 items per row)
          key={statusItem.status}
        >
          <div className="status-item">
            <Tooltip title={statusItem.label}>
              <Badge
                color={statusItem.color}
                text={statusItem.label}
                style={{
                  backgroundColor: "transparent",
                  fontSize: "16px",
                  width: "100%",
                  textAlign: "center",
                  padding: "10px",
                }}
              />
            </Tooltip>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default BookingStatusWidgetV2;
